<template>
    <div class="detalhes-fluxo">
        <b-modal
            ref="modalDetalheFluxoInfo"
            id="modal-detalhe-fluxo-info"
            size="xl"
            no-close-on-esc
            no-close-on-backdrop
            :title="`Detalhes de Linha - ${ planoDeContaTemp.descricao }`"
            tabindex="-1"
            >
            <el-table
                class="p-table"
                v-loading="loadingDetalhe"
                :data="detalhesModal.detalhes || []"
                style="width: 100%"
                height="350"
                stripe
                border
                size="mini">

                <el-table-column
                    prop="data"
                    label="Data"
                    width="100"
                    align="center">
                </el-table-column>

                <el-table-column
                    prop="empresa"
                    label="Empresa"
                    align="left">
                    <template slot="header" slot-scope="scope">
                        Empresa
                        <el-popover
                        placement="bottom"
                        trigger="click"
                        v-model="filterIsVisible"
                        width="400">
                            <div>
                                <el-select
                                    v-model="empresaId"
                                    filterable
                                    clearable
                                    :placeholder="`Selecione uma empresa`"
                                    style="width:100%; display:block; margin-bottom: 7px;"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in detalhesModal.empresas"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                            <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter">Limpar</el-button>
                            <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="meioDePagamento"
                    label="Meio de pagamento"
                    width="170"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="fornecedor"
                    show-overflow-tooltip
                    label="Fornecedor"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="historico"
                    show-overflow-tooltip
                    label="Historico"
                    align="left">
                </el-table-column>

                <el-table-column
                    prop="valor"
                    label="Valor"
                    width="150"
                    align="right">
                </el-table-column>
                
            </el-table>
            <template #modal-footer="{ hide }">
                <div class="left-btn">
                    <el-button size="small" type="success" icon="el-icon-download" @click="exportarDetalhes" :loading="loadingExportar">Exportar</el-button>
                </div>
                <div class="float-right">
                    <el-button size="small" @click="hide()">Fechar</el-button>
                </div>
			</template>
            <br>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pagination.pageSize"
                :current-page.sync="pagination.page"
                layout="sizes, prev, pager, next"
                background
                class="text-center"
                :total="pagination.total"
                >
            </el-pagination>
        </b-modal>


        <el-collapse v-if="premiumUser()" v-model="activeNamesCollapse">
            <el-collapse-item v-if="datas.linhas" :name="i" v-bind:key="i" v-for="(detalhe,i) in datas.linhas" class="det-list-item">
                <template slot="title">
                    <el-row :gutter="10" class="det-header">
                        <el-col :span="20">
                            {{ detalhe.nome }}
                        </el-col>
                        <el-col :span="4" :class="formatClassColor(detalhe.valores[datas.index])">
                            {{ toMoney(detalhe.valores[datas.index]) }}
                        </el-col>
                    </el-row>
                </template>
                <div>
                    <el-table
                        class="p-table"
                        :data="detalhe.detalhes || []"
                        style="width: 100%"
                        stripe
                        border
                        size="mini">

                        <el-table-column
                            prop="descricao"
                            label="Nome"
                            align="left">
                        </el-table-column>
                        
                        <el-table-column
                            prop="valores"
                            label="Valor"
                            align="center"
                            width="100">
                            <template slot-scope="scope" v-if="scope.row">
                                <span :class="formatClassColor(scope.row.valores[datas.index])">
                                    {{ toMoney(scope.row.valores[datas.index]) }}
                                </span>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="Ação"
                            width="170"
                            align="center">
                            <template slot-scope="scope" v-if="scope.row">
                                <el-button round icon="el-icon-view" size="mini" @click="getDetalhe(scope.row)">Detalhes</el-button>
                            </template>
                        </el-table-column>
                        
                    </el-table>
                </div>
            </el-collapse-item>
            <div v-if="!datas.linhas" class="det-list-item">
                <el-table
                    class="p-table"
                    :data="datas.detalhes || []"
                    style="width: 100%"
                    stripe
                    show-summary
                    :summary-method="setTotal"
                    border
                    size="mini">

                    <el-table-column
                        prop="descricao"
                        label="Nome"
                        align="left">
                    </el-table-column>
                    
                    <el-table-column
                        prop="valores"
                        label="Valor"
                        align="center"
                        width="100">
                        <template slot-scope="scope" v-if="scope.row">
                            <span :class="formatClassColor(scope.row.valores[datas.index])">
                                {{ toMoney(scope.row.valores[datas.index]) }}
                            </span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        label="Ação"
                        width="170"
                        align="center">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-button round icon="el-icon-view" size="mini" @click="getDetalhe(scope.row)">Detalhes</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-collapse>
        <div v-else>
            <el-alert
                title="Não possui acesso"
                description="Detalhe de DRE está disponível apenas para usuários premium."
                type="info">
            </el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'detalhe-fluxo-caixa',
        props: [
            'datas'
        ],
        data() {
            return {
                activeNamesCollapse: [0],
                loadingDetalhe: false,
                filterIsVisible: false,
                loadingExportar: false,
                detalhesModal: {},
                planoDeContaTemp: {},
                empresaId: '',
                pagination: {
                    page: 1,
                    pageSize: 10,
                    total: 0
                }
            }
        },
        computed: {
            fluxoDeCaixaFiltros: {
                get() {
                    return this.$store.state.fluxoDeCaixaFiltros;
                },
                set(value) {
                    this.$store.commit('updateFluxoDeCaixaFiltros', value);
                }
            }
        },
        methods: {
            toMoney(num){ // FORMATA REAL
                let n = num.valor ? num.valor : 0;
                return n ? Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
            },
            formatClassColor(num){
                let n = num.valor ? num.valor : 0;
                return n >= 0 ? 'positive' : 'negative';
            },
            setTotal() {
                return ['Valor total',this.toMoney(this.datas.total)]
            },
            handleSizeChange(val) {
                this.pagination.pageSize = val
                this.pagination.page = 1
                this.getDetalhe(this.planoDeContaTemp)
            },
            handleCurrentChange(val) {
                this.pagination.page = val
                this.getDetalhe(this.planoDeContaTemp)
            },
            setFilter() {
                this.pagination.page = 1
                this.getDetalhe(this.planoDeContaTemp)
            },
            clearFilter() {
                this.empresaId = ''
                this.getDetalhe(this.planoDeContaTemp)
            },
            async getDetalhe(model) {
                this.planoDeContaTemp = model;

                try {
                    this.loadingDetalhe = true;
                    this.$bvModal.show('modal-detalhe-fluxo-info');

                    const {
                        data,
                        status
                    } = await this.axios.post(this.$urls.FLUXO_CAIXA_OBTER_DETALHE, {
                        PlanoDeContasId: model.planoDeContaId,
                        data: this.datas.datas[this.datas.index],
                        PesquisaModel: this.fluxoDeCaixaFiltros,
                        Page: this.pagination.page,
                        PageSize: this.pagination.pageSize,
                        empresaId: this.empresaId
                    });

                    if (status !== 200) {
                        this.$notify.error({
                            title: 'Obter detalhe',
                            message: `Não foi possível obter detalhes para ${model.nome}`,
                            position: 'top-left'
                        });
                        return;
                    }

                    this.detalhesModal = data;
                    this.pagination.total = data.total;
                    

                } catch (err) {
                    this.$notify.error({
                        title: 'Erro interno',
                        message: 'Algum erro interno ocorreu, por favor entre em contato com nosso suporte',
                        position: 'top-left'
                    });
                } finally {
                    this.loadingDetalhe = false;
                    this.filterIsVisible = false;
                }
            },
            async exportarDetalhes() { 
                try {
                    this.loadingExportar = true
                    const response = await this.axios.post(this.$urls.FLUXO_CAIXA_EXPORTAR_DETALHE, {
                        PlanoDeContasId: this.planoDeContaTemp.planoDeContaId,
                        data: this.datas.datas[this.datas.index],
                        PesquisaModel: this.fluxoDeCaixaFiltros,
                        Page: this.pagination.page,
                        PageSize: this.pagination.pageSize
                    });

                    if(response.status !== 200) {
                        this.$notify.error({
                            title: 'Exportar detalhe',
                            message: `Não foi possível Exportar detalhes para ${model.nome}`,
                            position:'top-left'
                        });
                        return
                    }
                    this.$notify({
                        type: "success",
                        title: 'Gerando Relatório',
                        dangerouslyUseHTMLString: true,
                        message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
                    });

                } catch(err) {
                    this.$notify.error({
                        title: 'Erro interno',
                        message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                        position:'top-left'
                    });
                } finally {
                    this.loadingExportar = false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .det-list-item {
        .positive {
            color:#28a745 !important;
        }
        .negative {
            color:#dc3545 !important;
        }
    }
    .det-header {
        width:100%;
    }
    .left-btn {
        position: absolute; 
        left: 15px;
    }
</style>
<style lang="scss">
    .detalhes-fluxo {
        .el-collapse-item__content {
            background: #f7f7f7;
            padding: 10px;
        }
        .el-table__footer-wrapper {
            font-weight: 900;
        }
    }
    .p-table {
        tr.el-table__row td.el-table__cell {
            background: #fff;
        }
        tr.el-table__row:hover td.el-table__cell {
            background: #f5faff !important;
        }
    }
</style>